import { Button, Stack, useTheme } from '@mui/material';
import { FC, useContext } from 'react';
import FacebookAddPasswordContext from '../../contexts/FacebookAddPasswordContext';
import GlobalContext from '../../contexts/GlobalContext';
import { IconCircleCheck2, IconCircleCheck3 } from '../../icons/Icons';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';
import ScreenHeader from '../ScreenHeader/ScreenHeader';

const FacebookAddPasswordSuccess: FC = () => {
    const { language, fullLoginLink, coBranding } = useContext(GlobalContext);
    const { email } = useContext(FacebookAddPasswordContext);
    const theme = useTheme();

    const handleConfirm = () => {
        window.location.assign(fullLoginLink);
    };

    return (
        <PageLayoutV2>
            <Stack alignItems={'center'} sx={{ my: 3 }}>
                {coBranding.brandColor ? (
                    <IconCircleCheck3 fillColor={theme.palette.primary.main} />
                ) : (
                    <IconCircleCheck2 />
                )}
                <ScreenHeader
                    title={language.deprecateFacebook.success.title}
                    desc={language.deprecateFacebook.success.desc(email)}
                    size="large"
                />
                <Button variant="contained" type="submit" size="large" fullWidth onClick={handleConfirm}>
                    {language.deprecateFacebook.password.cta}
                </Button>
            </Stack>
        </PageLayoutV2>
    );
};

export default FacebookAddPasswordSuccess;
